<div
  class="person-multi-select"
  [class.person-multi-select--open]="open()"
  [class.person-multi-select--disabled]="disabled()"
>
  @if (selected().length > 0) {
    <ul class="person-multi-select__chips" role="list">
      @for (person of selected(); track person.id) {
        <li class="person-multi-select__chip">
          <app-avatar [name]="person.displayName" [size]="20" />
          <span class="person-multi-select__chip-name">{{ person.displayName }}</span>
          @if (!disabled()) {
            <button
              type="button"
              class="person-multi-select__chip-remove"
              [attr.aria-label]="removeKey() | translate"
              (click)="remove(person.id)"
            >
              <mat-icon aria-hidden="true">close</mat-icon>
            </button>
          }
        </li>
      }
    </ul>
  }

  <div class="person-multi-select__trigger-wrap">
    @if (label()) {
      <span class="person-multi-select__label">{{ label() }}</span>
    }
    <button
      #triggerBtn
      cdkOverlayOrigin
      #triggerOrigin="cdkOverlayOrigin"
      type="button"
      class="person-multi-select__trigger"
      [attr.aria-haspopup]="'listbox'"
      [attr.aria-expanded]="open()"
      [attr.aria-label]="label() || (placeholderKey() | translate)"
      [disabled]="disabled()"
      (click)="toggle()"
    >
      <mat-icon class="person-multi-select__trigger-icon" aria-hidden="true">person_add</mat-icon>
      <span class="person-multi-select__placeholder">{{ placeholderKey() | translate }}</span>
      <span class="person-multi-select__spacer"></span>
      <mat-icon class="person-multi-select__chevron" aria-hidden="true">expand_more</mat-icon>
    </button>
  </div>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="triggerOrigin"
    [cdkConnectedOverlayOpen]="open()"
    [cdkConnectedOverlayHasBackdrop]="true"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    [cdkConnectedOverlayPanelClass]="'person-multi-select__overlay-panel'"
    [cdkConnectedOverlayPositions]="[
      { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top', offsetY: 6 },
      { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom', offsetY: -6 },
    ]"
    [cdkConnectedOverlayWidth]="triggerOrigin.elementRef.nativeElement.offsetWidth"
    (backdropClick)="close(false)"
    (detach)="close(false)"
  >
    <div class="person-multi-select__pop">
      <div class="person-multi-select__search">
        <mat-icon aria-hidden="true">search</mat-icon>
        <input
          #searchInput
          type="text"
          class="person-multi-select__search-input"
          role="combobox"
          aria-autocomplete="list"
          [attr.aria-expanded]="open()"
          aria-controls="pms-listbox"
          [attr.aria-activedescendant]="activeId()"
          [attr.aria-label]="searchPlaceholderKey() | translate"
          [placeholder]="searchPlaceholderKey() | translate"
          [value]="query()"
          (input)="onSearchInput($event)"
          (keydown)="onSearchKeydown($event)"
        />
      </div>
      <ul id="pms-listbox" class="person-multi-select__list" role="listbox" aria-multiselectable="true">
        @for (option of filtered(); track option.id) {
          <li>
            <button
              type="button"
              [id]="optionDomId(option.id)"
              class="person-multi-select__option"
              [class.person-multi-select__option--selected]="isSelected(option.id)"
              [class.person-multi-select__option--active]="isActive(option.id)"
              role="option"
              [attr.aria-selected]="isSelected(option.id)"
              (click)="toggleOption(option.id)"
              tabindex="-1"
            >
              <app-avatar [name]="option.displayName" [size]="26" />
              <span class="person-multi-select__option-name">{{ option.displayName }}</span>
              @if (isSelected(option.id)) {
                <mat-icon class="person-multi-select__option-check" aria-hidden="true">check</mat-icon>
              }
            </button>
          </li>
        }
        @if (filtered().length === 0) {
          <li class="person-multi-select__empty">{{ emptyKey() | translate }}</li>
        }
      </ul>
    </div>
  </ng-template>
</div>
